import { Container, IInit } from 'common/container/Container'
import { NotificationContainerConfig } from '../container'
import { Observable, throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { HTTP_CLIENT_KEY, IHTTPClient } from 'common/api/HTTPClient'
import { IStatusService } from 'common/status/StatusService'
import { STATUS_SERVICE_KEY } from 'container/app'
import { UserDTO } from 'modules/users/models/User'
import { LangType } from 'modules/content/enums/LangType'

export interface IExternalInvitationApi extends IInit {
  sendInvitation(mail: string, mailLanguage: LangType): Observable<boolean>

  registerUser(
    user: UserDTO,
    registerToken: string,
    password: string
  ): Observable<UserDTO | undefined>
}

export class ExternalInvitationApi implements IExternalInvitationApi {
  private _container!: Container
  private _httpClient!: IHTTPClient
  private _url!: string
  private _statusService!: IStatusService

  init(c: Container) {
    this._container = c
    this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    this._url =
      (this._container.config as NotificationContainerConfig).moduleFullUrl +
      '/professional-invitations'
  }

  sendInvitation(mail: string, mailLanguage: LangType): Observable<boolean> {
    return this._httpClient
      .post<boolean>({ url: this._url, body: { email: mail, language: mailLanguage } })
      .pipe(
        map(() => {
          return true
        }),
        catchError((err) => {
          this._statusService.sendStatus({ variant: 'error', error: err })
          return throwError(err)
        })
      )
  }

  registerUser(
    user: UserDTO,
    registerToken: string,
    password: string
  ): Observable<UserDTO | undefined> {
    return this._httpClient
      .post<UserDTO>({
        url: `${this._url}/register`,
        body: { ...user, token: registerToken, password: password },
      })
      .pipe(
        catchError((err) => {
          this._statusService.sendStatus({ variant: 'error', error: err })
          return throwError(err)
        })
      )
  }
}
